import { Container } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import AppHeader from "@saleor/components/AppHeader";
import FilterBar from "@saleor/components/FilterBar";
import PageHeader from "@saleor/components/PageHeader";
import useUser from "@saleor/hooks/useUser";
import { SellerOrdersReport_sellerOrders_edges_node } from "@saleor/sellerOrders/types/SellerOrdersReport";
import { FilterPageProps, ListProps, TabPageProps } from "@saleor/types";
import React from "react";
import { useIntl } from "react-intl";

import { SellerOrdersList } from "../SellerOrdersList";
import {
  createFilterStructure,
  SellerOrdersFilterKeys,
  SellerOrdersFilterOpts
} from "./filters";

export interface SellerOrderListPageProps
  extends ListProps,
    FilterPageProps<SellerOrdersFilterKeys, SellerOrdersFilterOpts>,
    TabPageProps {
  sellerOrders: SellerOrdersReport_sellerOrders_edges_node[];
  onBack: () => void;
  download: () => void;
}

export const SellerOrdersListPage: React.FC<SellerOrderListPageProps> = ({
  currentTab,
  filterOpts,
  initialSearch,
  onSearchChange,
  onFilterChange,
  onAll,
  onTabChange,
  onTabDelete,
  onTabSave,
  tabs,
  sellerOrders,
  currencySymbol,
  onBack,
  download,
  ...listProps
}) => {
  const { user } = useUser();
  const intl = useIntl();
  const structure = createFilterStructure(intl, filterOpts, user.userType.code);
  return (
    <>
      <Container>
        <AppHeader onBack={onBack}>
          {intl.formatMessage({
            defaultMessage: "Reports",
            description: "reports"
          })}
        </AppHeader>
        <PageHeader title="Seller Store Order">
          <Button
            color="primary"
            variant="contained"
            disabled={!sellerOrders}
            onClick={download}
          >
            Download
          </Button>
        </PageHeader>

        <Card>
          <FilterBar
            allTabLabel={intl.formatMessage({
              defaultMessage: "All",
              description: "tab name"
            })}
            currencySymbol={currencySymbol}
            currentTab={currentTab}
            tabs={tabs}
            filterStructure={structure}
            searchPlaceholder={intl.formatMessage({
              defaultMessage: "Search Store Order Code"
            })}
            initialSearch={initialSearch}
            onSearchChange={onSearchChange}
            onFilterChange={onFilterChange}
            onAll={onAll}
            onTabChange={onTabChange}
            onTabDelete={onTabDelete}
            onTabSave={onTabSave}
          />

          <SellerOrdersList sellerOrders={sellerOrders} {...listProps} />
        </Card>
      </Container>
    </>
  );
};

export default SellerOrdersListPage;
